import React, { memo, useCallback } from 'react'

import { useTranslation } from 'react-i18next'
import Grid from '@material-ui/core/Grid'
// import { buildTeamCover } from 'utils'
import ReactPlayer from 'react-player'
import Fab from '@material-ui/core/Fab'
import { makeStyles } from '@material-ui/styles'
import DOMPurify from 'dompurify'

import CompanyHeaderImage from 'assets/images/company-header-image.jpg'
import styles from '../../styles'
import { buildTeamCover, buildCompanyCover } from 'utils'

const useStyles = makeStyles(styles)

const CardDescription: React.FunctionComponent<any> = ({
	company,
	team,
	onClickLearnMore,
}) => {
	// const history = useHistory()
	const { t } = useTranslation()
	const classes = useStyles()
	const { description, name } = team ? team : company

	const handleOnClickLearnMore = useCallback(
		(value: 'company' | 'team') => onClickLearnMore(value),
		[onClickLearnMore],
	)

	return (
		<Grid container={true}>
			<Grid
				item={true}
				xs={12}
				sm={8}
				// className={classes.teamResourceContainer}
			>
				{team &&
					(team.hasCover ? (
						<>
							<img
								src={buildTeamCover(team)}
								// src={CompanyImage}
								className={classes.cardImage}
								alt=""
							/>
						</>
					) : team.featuredVideo ? (
						<div className={classes.video}>
							<ReactPlayer
								url={team.featuredVideo}
								className={classes.player}
								controls={true}
								width="100%"
								height="100%"
							/>
						</div>
					) : (
						<img
							src={CompanyHeaderImage}
							className={classes.cardImage}
							alt=""
						/>
					))}

				{company &&
					(company.hasCover ? (
						<img
							src={buildCompanyCover(company)}
							className={classes.cardImage}
							alt=""
						/>
					) : company.featuredVideo ? (
						<div className={classes.video}>
							<ReactPlayer
								url={company.featuredVideo}
								className={classes.player}
								controls={true}
								width="100%"
								height="100%"
							/>
						</div>
					) : (
						<img
							src={CompanyHeaderImage}
							className={classes.cardImage}
							alt=""
						/>
					))}
			</Grid>
			<Grid
				xs={12}
				sm={4}
				item={true}
				className={classes.teamHeadDescriptionRoot}
			>
				<h3 className={classes.teamHeadTitle}>{name}</h3>
				<div className={classes.teamHeadDesc}>
					<div
						className={classes.wisiwygContent}
						dangerouslySetInnerHTML={{
							__html: DOMPurify.sanitize(description),
						}}
					></div>
				</div>
				<Fab
					variant="extended"
					size="small"
					color="primary"
					aria-label="Share"
					className={classes.learnMoreBtn}
					onClick={() =>
						handleOnClickLearnMore(team ? 'team' : 'company')
					}
				>
					<span>{t('Learn more')}</span>
				</Fab>
			</Grid>
		</Grid>
	)
}
export default memo((props: any) => <CardDescription {...props} />)
